import React, { FC, PropsWithChildren, PureComponent } from 'react';
import { styled } from 'linaria/react';
interface Props {
  marginTop?: number;
  marginRight?: number;
  marginBottom?: number;
  marginLeft?: number;
  paddingTop?: number;
  paddingRight?: number;
  paddingBottom?: number;
  paddingLeft?: number;
}
interface StaticProps {
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
  mobTop?: number;
  mobRight?: number;
  mobBottom?: number;
  mobLeft?: number;
  minTop?: number;
  minRight?: number;
  minBottom?: number;
  minLeft?: number;
}
class Content extends PureComponent<PropsWithChildren<Props>> {
  static Padding: FC<PropsWithChildren<StaticProps>> = ({
    children,
    top,
    mobTop,
    minTop,
    right,
    mobRight,
    minRight,
    bottom,
    mobBottom,
    minBottom,
    left,
    mobLeft,
    minLeft
  }) => <PaddingWrapper top={top} mobTop={mobTop} minTop={minTop} right={right} mobRight={mobRight} minRight={minRight} bottom={bottom} mobBottom={mobBottom} minBottom={minBottom} left={left} mobLeft={mobLeft} minLeft={minLeft}>
      {children}
    </PaddingWrapper>;
  static Margin: FC<PropsWithChildren<StaticProps>> = ({
    children,
    top,
    mobTop,
    minTop,
    right,
    mobRight,
    minRight,
    bottom,
    mobBottom,
    minBottom,
    left,
    mobLeft,
    minLeft
  }) => <MarginWrapper top={top} mobTop={mobTop} minTop={minTop} right={right} mobRight={mobRight} minRight={minRight} bottom={bottom} mobBottom={mobBottom} minBottom={minBottom} left={left} mobLeft={mobLeft} minLeft={minLeft}>
      {children}
    </MarginWrapper>;
  render() {
    const {
      children,
      marginTop,
      marginRight,
      marginBottom,
      marginLeft,
      paddingTop,
      paddingRight,
      paddingLeft,
      paddingBottom
    } = this.props;
    return <Wrapper marginTop={marginTop} marginRight={marginRight} marginBottom={marginBottom} marginLeft={marginLeft} paddingTop={paddingTop} paddingRight={paddingRight} paddingBottom={paddingBottom} paddingLeft={paddingLeft}>
        {children}
      </Wrapper>;
  }
}
const _exp = /*#__PURE__*/() => ({
  minTop
}) => minTop ? `${minTop}px` : 0;
const _exp2 = /*#__PURE__*/() => ({
  minRight
}) => minRight ? `${minRight}px` : 0;
const _exp3 = /*#__PURE__*/() => ({
  minBottom
}) => minBottom ? `${minBottom}px` : 0;
const _exp4 = /*#__PURE__*/() => ({
  minLeft
}) => minLeft ? `${minLeft}px` : 0;
const _exp5 = /*#__PURE__*/() => ({
  mobTop
}) => mobTop ? `${mobTop}px` : 0;
const _exp6 = /*#__PURE__*/() => ({
  mobRight
}) => mobRight ? `${mobRight}px` : 0;
const _exp7 = /*#__PURE__*/() => ({
  mobBottom
}) => mobBottom ? `${mobBottom}px` : 0;
const _exp8 = /*#__PURE__*/() => ({
  mobLeft
}) => mobLeft ? `${mobLeft}px` : 0;
const _exp9 = /*#__PURE__*/() => ({
  top
}) => top ? `${top}px` : 0;
const _exp0 = /*#__PURE__*/() => ({
  right
}) => right ? `${right}px` : 0;
const _exp1 = /*#__PURE__*/() => ({
  bottom
}) => bottom ? `${bottom}px` : 0;
const _exp10 = /*#__PURE__*/() => ({
  left
}) => left ? `${left}px` : 0;
const PaddingWrapper = /*#__PURE__*/styled('div')({
  name: "PaddingWrapper",
  class: "pvjt194",
  propsAsIs: false,
  vars: {
    "pvjt194-0": [_exp()],
    "pvjt194-1": [_exp2()],
    "pvjt194-2": [_exp3()],
    "pvjt194-3": [_exp4()],
    "pvjt194-4": [_exp5()],
    "pvjt194-5": [_exp6()],
    "pvjt194-6": [_exp7()],
    "pvjt194-7": [_exp8()],
    "pvjt194-8": [_exp9()],
    "pvjt194-9": [_exp0()],
    "pvjt194-10": [_exp1()],
    "pvjt194-11": [_exp10()]
  }
});
const _exp11 = /*#__PURE__*/() => ({
  minTop
}) => minTop ? `${minTop}px` : 0;
const _exp12 = /*#__PURE__*/() => ({
  minRight
}) => minRight ? `${minRight}px` : 0;
const _exp13 = /*#__PURE__*/() => ({
  minBottom
}) => minBottom ? `${minBottom}px` : 0;
const _exp14 = /*#__PURE__*/() => ({
  minLeft
}) => minLeft ? `${minLeft}px` : 0;
const _exp15 = /*#__PURE__*/() => ({
  mobTop
}) => mobTop ? `${mobTop}px` : 0;
const _exp16 = /*#__PURE__*/() => ({
  mobRight
}) => mobRight ? `${mobRight}px` : 0;
const _exp17 = /*#__PURE__*/() => ({
  mobBottom
}) => mobBottom ? `${mobBottom}px` : 0;
const _exp18 = /*#__PURE__*/() => ({
  mobLeft
}) => mobLeft ? `${mobLeft}px` : 0;
const _exp19 = /*#__PURE__*/() => ({
  top
}) => top ? `${top}px` : 0;
const _exp20 = /*#__PURE__*/() => ({
  right
}) => right ? `${right}px` : 0;
const _exp21 = /*#__PURE__*/() => ({
  bottom
}) => bottom ? `${bottom}px` : 0;
const _exp22 = /*#__PURE__*/() => ({
  left
}) => left ? `${left}px` : 0;
const MarginWrapper = /*#__PURE__*/styled('div')({
  name: "MarginWrapper",
  class: "m997kcd",
  propsAsIs: false,
  vars: {
    "m997kcd-0": [_exp11()],
    "m997kcd-1": [_exp12()],
    "m997kcd-2": [_exp13()],
    "m997kcd-3": [_exp14()],
    "m997kcd-4": [_exp15()],
    "m997kcd-5": [_exp16()],
    "m997kcd-6": [_exp17()],
    "m997kcd-7": [_exp18()],
    "m997kcd-8": [_exp19()],
    "m997kcd-9": [_exp20()],
    "m997kcd-10": [_exp21()],
    "m997kcd-11": [_exp22()]
  }
});
const _exp23 = /*#__PURE__*/() => ({
  marginTop
}) => marginTop ? `${marginTop}px` : 0;
const _exp24 = /*#__PURE__*/() => ({
  marginRight
}) => marginRight ? `${marginRight}px` : 0;
const _exp25 = /*#__PURE__*/() => ({
  marginBottom
}) => marginBottom ? `${marginBottom}px` : 0;
const _exp26 = /*#__PURE__*/() => ({
  marginLeft
}) => marginLeft ? `${marginLeft}px` : 0;
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wv3o1yt",
  propsAsIs: false,
  vars: {
    "wv3o1yt-0": [_exp23()],
    "wv3o1yt-1": [_exp24()],
    "wv3o1yt-2": [_exp25()],
    "wv3o1yt-3": [_exp26()]
  }
});
export default Content;

require("./Content.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Content.tsx");